<template>
  <div class="page-header d-flex justify-content-center">
    <span class="page-header--text">{{text}}</span>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  components: {},
  props: ["text"],
  data: function() {
    return {};
  }
};
</script>
